// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__10G3M","social":"footer_social__Rykw6","link":"footer_link__1qlN1","copyright":"footer_copyright__BTgpp","contacts":"footer_contacts__l_Bao"};